import { getDistance, getDistanceAlongPath, getElevationAlongPath } from '@m1/geo-utils';
import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import { useDispatch, useSelector } from 'react-redux';

import actions from '@/actions';
import { SAFETY_MARGIN } from '@/config';
import { NotifierService as notifier } from '@/libs/Notifier';

const useCollisionChecker = () => {
  const dispatch = useDispatch();
  const path = useSelector((state) => state.editor.path);

  useUpdateEffect(() => {
    if (path.length === 0) {
      dispatch(actions.mission.setCollisions([]));
      dispatch(actions.mission.setElevations([]));
      return;
    }

    checkCollision();
  }, [path]);

  const checkCollision = async () => {
    const elevations = await getElevationAlongPath(path.map(({ position }) => position));
    const pathPoints = getPathPoints(elevations.length);

    const collisions = [];
    for (let j = 0; j < pathPoints.length - 1; j++) {
      const { x: x1, y: y1 } = pathPoints[j];
      const { x: x2, y: y2 } = pathPoints[j + 1];

      const slope = (y2 - y1) / (x2 - x1);
      const yIntercept = y1 - slope * x1;

      for (let i = x1; i <= x2; i++) {
        const altitude = slope * i + yIntercept;
        const collision = elevations[i] + SAFETY_MARGIN;

        collisions.push(altitude < collision ? collision : null);
      }
    }

    dispatch(actions.mission.setCollisions(collisions));
    dispatch(actions.mission.setElevations(elevations));

    if (collisions.some((collision) => collision !== null)) {
      notifier.warning(`A clearance of at least ${SAFETY_MARGIN}m is recommended for safety.`);
    }
  };

  const getPathPoints = (sampleCount) => {
    // 총 거리
    const wholeDistance = getDistanceAlongPath(path.map(({ position }) => position));
    // 누적 거리
    let accumulatedDistance = 0;
    const slicedPath = path.slice(1); // 이륙 지점 지면 위치 제외

    return slicedPath.map((pathItem, index) => {
      let x = 0;
      if (index > 0) {
        const from = slicedPath[index - 1].position;
        const to = pathItem.position;
        accumulatedDistance += getDistance(from, to);

        if (wholeDistance > 0) {
          x = Math.round((accumulatedDistance / wholeDistance) * (sampleCount - 1));
        }
      }

      return { x, y: pathItem.mslAltitude };
    });
  };
};

export default useCollisionChecker;
